import { SText } from '@setvi/shared/components';
import { ColumnsType } from '@setvi/shared/types';
import { RecordType } from '@setvi/shared/interfaces';
import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { SpecificationComponent } from './components';

export const useSpecificationColumns = () => {
  const flags = useFlags();

  const specificationColumns: ColumnsType = useMemo(
    () => [
      {
        id: 'label',
        label: 'Label',
        width: '200px',
        maxWidth: '200px',
        cellContent: (row: RecordType) => (
          <SText title={row.label} noLineClamp />
        )
      },
      {
        id: 'value',
        label: 'Value',
        width: '100%',
        style: {
          overflow: 'hidden',
          maxHeight: 'none',
          width: '100%',
          maxWidth: '100%'
        },
        cellContent: (row: RecordType) => (
          <SpecificationComponent recordType={row} />
        )

        /* flags?.productAssistant ? (
            <Tooltip
              enterDelay={200}
              title={
                <SButton
                  startIcon={<AIIcon fill="#fff" />}
                  onClick={() => {
                    setValue(JSON.stringify(row?.value));
                    if (!openAskAi) setOpenAskAi(true);
                  }}
                  variant="text"
                  style={{
                    color: '#fff',
                    fontSize: 14,
                    minHeight: 0,
                    padding: 0,
                    height: 'fit-content',
                    width: 'fit-content'
                  }}>
                  Ask AI
                </SButton>
              }
              interactive>
              <Box width="fit-content">
                <SpecificationComponent recordType={row} />
              </Box>
            </Tooltip>
          )  */
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [flags?.productAssistant]
  );

  return { specificationColumns };
};
